var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M7.967 12.183a4.217 4.217 0 118.433 0 4.217 4.217 0 01-8.433 0zm4.217-5.65a5.65 5.65 0 100 11.3 5.65 5.65 0 000-11.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M15.406 2.204l-.69-.737a3.467 3.467 0 00-5.066 0l-.69.737a2.034 2.034 0 01-1.554.644l-1.01-.034a3.467 3.467 0 00-3.582 3.583l.034 1.009a2.034 2.034 0 01-.644 1.555l-.737.69s0 0 0 0a3.467 3.467 0 000 5.066l.737.69c.43.4.664.967.644 1.554l-.034 1.01a3.467 3.467 0 003.583 3.582l1.009-.034a2.034 2.034 0 011.555.644l.69.737a3.467 3.467 0 005.066 0l.69-.737a2.034 2.034 0 011.554-.644l1.01.034a3.467 3.467 0 003.582-3.583l-.034-1.01a2.034 2.034 0 01.644-1.554l.737-.69a3.467 3.467 0 000-5.066l-.737-.69a2.034 2.034 0 01-.644-1.554l.034-1.01a3.467 3.467 0 00-3.583-3.582l-1.01.034a2.034 2.034 0 01-1.554-.644h0zm-1.736.241l.689.738a3.467 3.467 0 002.65 1.098l1.01-.034a2.034 2.034 0 012.101 2.101l-.034 1.01a3.468 3.468 0 001.098 2.65l.738.69c.86.803.86 2.168 0 2.971l-.738.69a3.468 3.468 0 00-1.098 2.65l.034 1.01a2.034 2.034 0 01-2.101 2.101l-1.01-.034c-1-.034-1.966.367-2.65 1.098l-.69.738c-.803.86-2.168.86-2.972 0l-.69-.738a3.468 3.468 0 00-2.65-1.098l-1.009.034a2.034 2.034 0 01-2.101-2.101l.034-1.01c.034-1-.367-1.966-1.098-2.65l-.738-.69a2.034 2.034 0 010-2.972l.738-.69a3.467 3.467 0 001.098-2.65l-.034-1.009a2.034 2.034 0 012.101-2.101l1.01.034c1 .034 1.966-.367 2.65-1.098l.69-.738a2.034 2.034 0 012.971 0h0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5d9f76ae.svg";
export { ForwardRef as ReactComponent };